var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-template",class:[_vm.mapSize,_vm.mapLayout,_vm.$root.env]},[_c('div',[(_vm.cropImg)?_c('img',{attrs:{"src":_vm.cropImg,"alt":"Cropped Image"}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }